<template>
  <v-container>
    <v-row no-gutters class="mb-1" justify="space-between">
      <SalesAdder @update="getData"></SalesAdder>
      <v-btn elevation="0" exact :to="{ name: 'EventEditor' }">
        <v-icon left small>fa-calendar</v-icon>
        Calendrier
      </v-btn>
    </v-row>
    <v-card>
      <v-card-text>
        <DataFilter v-bind.sync="filter" @update="getData"></DataFilter>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-text>
        <AnalyticSalesSummary
          v-if="showType === 'date'"
          :data="data"
        ></AnalyticSalesSummary>
        <AnalyticEventsSummary
          v-else-if="showType === 'event'"
          :data="data"
        ></AnalyticEventsSummary>
        <v-row align="center" justify="center" no-gutters>
          <v-btn text small @click="showChart = !showChart">
            <v-icon small left v-if="showChart === false"
              >fa-chevron-down</v-icon
            >
            <v-icon small left v-else>fa-chevron-up</v-icon>
            <span v-if="showChart === false">Afficher les détails</span>
            <span v-else>Cacher les détails</span>
          </v-btn>
        </v-row>
      </v-card-text>
      <v-expand-transition>
        <v-card-text v-show="showChart === true" style="padding-top: 0;">
          <v-row align="start">
            <v-col cols="12" sm="6">
              <AnalycticTransactionChartFilter
                :category.sync="category"
                :tags.sync="tags"
                :use-tags.sync="useTags"
                :item-to-show.sync="itemToShow"
                @change="getTransactionData"
              ></AnalycticTransactionChartFilter>
              <AnalycticTransactionChart
                v-if="toggleRaw"
                chartId="transactionChart"
                :loading="chartLoading"
                :data="transactionData"
                :total-sales="getTotal"
                :total-cost="getCostTotal"
              ></AnalycticTransactionChart>
              <AnalycticTransactionChartRaw
                v-else
                chartId="transactionChartRaw"
                :loading="chartLoading"
                :data="transactionData"
                :total-sales="getTotal"
                :total-cost="getCostTotal"
              ></AnalycticTransactionChartRaw>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row align="center" justify="end" dense no-gutters>
                <v-btn
                  icon
                  @click="toggleRaw = !toggleRaw"
                  :color="toggleRaw === true ? '' : '#e5e5e5'"
                >
                  <v-icon>fa-percentage</v-icon>
                </v-btn>
                <v-select
                  dense
                  hide-details
                  filled
                  single-line
                  class="no-before"
                  placeholder="Nombre d'objet à afficher"
                  :items="nbItems"
                  v-model="itemToShow"
                  @change="getTransactionData"
                  style="max-width: 90px"
                ></v-select>
              </v-row>
              <AnalycticTransactionBarChart
                v-if="toggleRaw"
                chartId="transactionProductChart"
                :loading="chartLoading"
                :data="transactionProductData"
                :total-sales="getTotal"
                :total-cost="getCostTotal"
              ></AnalycticTransactionBarChart>
              <AnalycticTransactionBarChartRaw
                v-else
                chartId="transactionProductChartRaw"
                :loading="chartLoading"
                :data="transactionProductData"
                :total-sales="getTotal"
                :total-cost="getCostTotal"
              ></AnalycticTransactionBarChartRaw>
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
    </v-card>
    <v-card class="mt-3">
      <v-card-text v-if="showType === 'date'">
        <AnalyticSalesBarChart
          :data="data"
          :labels="getDateRange"
          :loading="loading"
        ></AnalyticSalesBarChart>
        <v-row class="mt-2" align="center" justify="center" no-gutters>
          <v-btn text small @click="showSalesDetails = !showSalesDetails">
            <v-icon small left v-if="showSalesDetails === false"
              >fa-chevron-down</v-icon
            >
            <v-icon small left v-else>fa-chevron-up</v-icon>
            <span v-if="showSalesDetails === false">Afficher les détails</span>
            <span v-else>Cacher les détails</span>
          </v-btn>
        </v-row>
        <v-expand-transition>
          <AnalyticSalesGrid
            v-if="showSalesDetails === true"
            :data="data"
            @update="getData"
          ></AnalyticSalesGrid>
        </v-expand-transition>
      </v-card-text>
      <v-card-text v-if="showType === 'event'">
        <AnalyticEventsBarChart
          :data="data"
          :event="event"
          :loading="loading"
        ></AnalyticEventsBarChart>
        <v-row class="mt-2" align="center" justify="center" no-gutters>
          <v-btn text small @click="showSalesDetails = !showSalesDetails">
            <v-icon small left v-if="showSalesDetails === false"
              >fa-chevron-down</v-icon
            >
            <v-icon small left v-else>fa-chevron-up</v-icon>
            <span v-if="showSalesDetails === false">Afficher les détails</span>
            <span v-else>Cacher les détails</span>
          </v-btn>
        </v-row>
        <v-expand-transition>
          <AnalyticEventsGrid
            v-if="showSalesDetails === true"
            :data="data"
            :event="event"
          ></AnalyticEventsGrid>
        </v-expand-transition>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { SalesAdder } from "@/modules/Ventes/components";
import { round10 } from "round10";
import {
  DataFilter,
  AnalyticSalesGrid,
  AnalyticSalesSummary,
  AnalyticEventsSummary,
  AnalyticEventsGrid,
  AnalycticTransactionChart,
  AnalycticTransactionBarChart,
  AnalycticTransactionChartFilter,
  AnalyticSalesBarChart,
  AnalyticEventsBarChart,
    AnalycticTransactionChartRaw,
  AnalycticTransactionBarChartRaw
} from "../components";
import moment from "moment";
export default {
  name: "AnalyticIndex",
  components: {
    SalesAdder,
    DataFilter,
    AnalyticSalesGrid,
    AnalyticSalesSummary,
    AnalyticEventsSummary,
    AnalyticEventsGrid,
    AnalycticTransactionChart,
    AnalycticTransactionBarChart,
    AnalycticTransactionChartFilter,
    AnalyticSalesBarChart,
    AnalyticEventsBarChart,
    AnalycticTransactionChartRaw,
    AnalycticTransactionBarChartRaw
  },
  created() {
    this.filter.store = [this.getStoreId];
    this.$store.dispatch("loadSaleOptionalValues");
    this.$store.dispatch("loadProducts");
    this.$store.dispatch("loadEvents");
    this.$store.dispatch("loadTagCategories");
    this.getData();
  },
  computed: {
    ...mapGetters(["getStoreId", "getTagCategories", "getEvents"]),
    getDateRange() {
      const dates = [];
      let currDate = moment(this.filter.dateRange[0]);
      const lastDate = moment(this.filter.dateRange[1]);

      while (currDate.diff(lastDate) <= 0) {
        dates.push(currDate.clone().format("YYYY-MM-DD"));
        currDate.add(1, "days");
      }

      return dates;
    },
    getTotal() {
      return round10(
        this.data.map(x => Number(x.sales)).reduce((a, b) => a + b, 0),
        0
      );
    },
    getCostTotal() {
      return round10(
        this.data.map(x => Number(x.cost)).reduce((a, b) => a + b, 0),
        0
      );
    }
  },
  data() {
    return {
      data: [],
      transactionData: [],
      transactionProductData: [],
      event: "",
      showType: "date",
      toggleRaw: true,
      filter: {
        store: [],
        dateRange: [
          moment()
            .startOf("week")
            .add(1, "d")
            .format("YYYY-MM-DD"),
          moment()
            .endOf("week")
            .add(1, "d")
            .format("YYYY-MM-DD")
        ],
        type: "date",
        event: ""
      },
      useTags: false,
      itemToShow: 10,
      showChart: false,
      showSalesDetails: false,
      category: "",
      tags: [],
      attribute: "quantity",
      loading: false,
      chartLoading: false,
      nbItems: [5, 10, 15, 20, 25, 50]
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.$store.dispatch("slo");
        this.event = this.filter.event;
        if (this.filter.type === "date") {
          this.data = await api.getSalesAnalytics({
            store: this.filter.store,
            start: this.filter.dateRange[0],
            end: this.filter.dateRange[1]
          });
        } else if (this.filter.type === "event") {
          this.data = await api.getEventsSalesAnalytics({
            store: this.filter.store,
            event: this.filter.event
          });
        }
        this.getTransactionData();
        this.showType = this.filter.type;
      } finally {
        this.loading = false;
        this.$store.dispatch("elo");
      }
    },
    getCostSalesRatio(item) {
      if (this.getTotal !== 0 && this.getCostTotal !== 0) {
        const costRatio = item.cost / this.getCostTotal;
        const saleRatio = item.retail_price / this.getTotal;
        return costRatio - saleRatio;
      } else {
        return item.cost;
      }
    },
    async getTransactionData() {
      try {
        this.chartLoading = true;
        if (
          (this.useTags === false &&
            this.category !== null &&
            this.category !== "") ||
          (this.useTags === true && this.tags.length > 0)
        ) {
          if (this.filter.type === "date") {
            const baseOptions = {
              store: this.filter.store,
              start: this.filter.dateRange[0],
              end: this.filter.dateRange[1],
              grouped: true
            };
            if (this.useTags === true) {
              baseOptions.tags = this.tags;
            } else {
              baseOptions.category = this.category;
            }

            this.transactionData = await api.getIntegratedTransactionsAnalytics(
              {
                ...baseOptions
              }
            );
            const productData = await api.getIntegratedTransactionsAnalytics({
              ...baseOptions,
              product: true
            });
            this.transactionProductData = productData
              .sort(
                (a, b) => this.getCostSalesRatio(b) - this.getCostSalesRatio(a)
              )
              .slice(0, this.itemToShow);
          } else if (this.filter.type === "event") {
            const currentYear = moment().format("YYYY");
            const currentEvent = this.getEvents.find(
              x => x.year === currentYear && x.name === this.filter.event
            );
            const baseOptions = {
              store: this.filter.store,
              start: currentEvent.start,
              end:
                currentEvent.end !== null
                  ? currentEvent.end
                  : currentEvent.start,
              grouped: true
            };
            if (this.useTags === true) {
              baseOptions.tags = this.tags;
            } else {
              baseOptions.category = this.category;
            }
            if (currentEvent !== undefined) {
              this.transactionData = await api.getIntegratedTransactionsAnalytics(
                {
                  ...baseOptions
                }
              );
              const productData = await api.getIntegratedTransactionsAnalytics({
                ...baseOptions,
                product: true
              });
              this.transactionProductData = productData
                .sort(
                  (a, b) =>
                    this.getCostSalesRatio(b) - this.getCostSalesRatio(a)
                )
                .slice(0, this.itemToShow);
            }
          } else {
            this.transactionData = [];
            this.transactionProductData = [];
          }
        }
      } finally {
        this.chartLoading = false;
      }
    }
  }
};
</script>

<style></style>
